import { Avatar, Stack, Typography } from '@mui/material';
import { useIsDesktop } from 'Hooks';

interface IFormTitle {
  icon: string;
  title: string;
}

export const FormTitle = ({ title, icon }: IFormTitle) => {
  const isDesktop = useIsDesktop();

  return (
    <Stack
      direction='row'
      gap={isDesktop ? '24px' : '16px'}
      width={isDesktop ? 'fit-content' : '100%'}
      alignItems='center'
      justifyContent={isDesktop ? undefined : 'center'}
    >
      {isDesktop && (
        <Avatar alt='' src={icon} sx={{ width: '40px', height: '40px' }} />
      )}
      <Typography
        variant='h2'
        component='h1'
        fontWeight={700}
        fontSize={isDesktop ? '24px' : '32px'}
        alignSelf={isDesktop ? undefined : 'center'}
        maxWidth={isDesktop ? undefined : '200px'}
        textAlign={isDesktop ? undefined : 'center'}
      >
        {title}
      </Typography>
    </Stack>
  );
};
